import axios from 'axios'
import moment from 'moment'
import { isUUID } from 'src/core/helpers'
import {
  ProjectAcquisitionPayload,
  ProjectDiscountApiPayload,
  PurchaseBrokeragePayload,
  ProjectDiscountPayload,
  ProjectApiPayload,
  Project,
} from 'src/core/models'

export async function createprojectAPI(payload: any): Promise<{ id: number, volume_credits: number }> {
  const { data } = await axios.post('/api/v1/projects/', payload)
  return { id: data.id, volume_credits: data.volume_credits }
}

export async function getProjectDetailsAPI(id: number, ignore_validation=false): Promise<Project> {
  const params = ignore_validation ? '?ignore_validation=True' : ''
  const url = `/api/v1/projects/${id}${params}`
  const { data } = await axios.get<Project>(url)
  return data
}

export async function createPurchaseOperationAPI(payload: ProjectAcquisitionPayload): Promise<string> {
  const { data } = await axios.post(`/api/v1/brokerage/create_purchase_operation/`, payload)
  return data
}

export async function createSaleBrokerageOperationAPI(payload: PurchaseBrokeragePayload): Promise<string> {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const url = `/api/v1/brokerage/create_stock_sale_operation/`
  const body = { ...payload, createdAt: payload.createdAt ? moment(payload.createdAt).format('YYYY-MM-DD') : null }
  const { data } = await axios.post<{ purchase_url: string }>(url, body, config)
  return `${process.env.NEXT_PUBLIC_API_URL}${data.purchase_url}`
}

export async function getUserProjectsAPI(userId: number): Promise<Project[]> {
  const params = `?user_id=${userId}&page_size=9999&is_draft=False&is_visible_in_climatetrade=True`
  const url = `/api/v1/projects/${params}`
  const { data } = await axios.get(url)
  return data?.results
}

export async function transferProjectAPI(projectId: number, email: string): Promise<any> {
  const { data } = await axios.put(`/api/v1/projects/${projectId}/transfer_new_ownership/`, { email })
  return data
}

export async function createBigProjectAPI(payload: ProjectApiPayload): Promise<Project> {
  const { data } = await axios.post<Project>('/api/v1/projects/', payload)
  return data
}

export async function editBigProjectAPI(projectId: number, payload: ProjectApiPayload): Promise<number> {
  const { data } = await axios.patch<Project>(`/api/v1/projects/${projectId}/`, payload)
  return data.id
}

export async function updateProjectFilesAPI(projectId: number, formData: FormData): Promise<{ id: number }> {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const { data } = await axios.patch<Project>(`/api/v1/projects/${projectId}/`, formData, config)
  return { id: data.id }
}

export async function uploadProjectImagesapi(projectId: number, filaImages: File[]) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  for (const picture of filaImages) {
    const formData = new FormData()
    formData.append('project', `${process.env.NEXT_PUBLIC_API_URL}/api/v1/projects/${projectId}/`)
    formData.append('image', picture)
    await axios.post(`/api/v1/projects_pictures/`, formData, config)
  }
}

export async function deleteProjectImageAPI(imageId: number) {
  await axios.delete(`/api/v1/projects_pictures/${imageId}/`)
}

export async function createProjectDiscountsAPI(project: Project, discounts: ProjectDiscountPayload[]) {
  for (const discount of discounts) {
    const payload: ProjectDiscountApiPayload = {
      ...discount,
      project: project.id,
      vintages: !project.is_vintage ? [] : project.vintage_items.filter(vintage => {
        return discount.vintages_data.some(v => v.year === vintage.year)
      }).map(v => v.id)
    }
    await axios.post('/api/v1/project_discounts/', payload)
  }
}

export async function manageDiscountEditionAPI(project: Project, discounts: ProjectDiscountPayload[]) {
  for (const discount of discounts) {
    const payload: ProjectDiscountApiPayload = {
      ...discount,
      project: project.id,
      vintages: !project.is_vintage ? [] : project.vintage_items.filter(vintage => {
        return discount.vintages_data.some(v => v.year === vintage.year)
      }).map(v => v.id)
    }
    // Create a new Discount
    if (isUUID(`${discount.id}`)) {
      await axios.post('/api/v1/project_discounts/', payload)
    }
    // Edit
    if (project.discounts.some(d => d.id === discount.id)) {
      await axios.patch(`/api/v1/project_discounts/${discount.id}/`, payload)
    }
  }
}

export async function deleteProjectDiscountAPI(discountId: number) {
  await axios.delete(`/api/v1/project_discounts/${discountId}/`)
}
